import { get, set } from "lodash";

const sessionStorage = window.sessionStorage;
const StoreKey = "__insurance__scroll-top-cache__";

function setCache(keys, value) {
  try {
    const cacheStr = sessionStorage.getItem(StoreKey);
    const cacheObj = cacheStr ? JSON.parse(cacheStr) : {};
    set(cacheObj, keys, value);
    sessionStorage.setItem(StoreKey, JSON.stringify(cacheObj));
  } catch (error) {}
}
function getCache(keys) {
  if (typeof keys === "string") {
    keys = [keys];
  }
  try {
    const currentValue = JSON.parse(sessionStorage.getItem(StoreKey));
    return get(currentValue, keys);
  } catch (error) {
    return null;
  }
}

const CacheScrollTop = {
  provide() {
    return {
      cacheScrollTopValue: this.cacheScrollTopValue,
    };
  },
  data() {
    return {
      scrollTopEl: document.documentElement || document.body,
      autoCacheScrollTop: true,
      path: this.$route.path,
    };
  },
  activated() {
    this.initScrollTop();
  },
  beforeRouteLeave(to, from, next) {
    this.cacheScrollTopValue();
    next();
  },
  methods: {
    initScrollTop() {
      try {
        const scrollTopValue = Number(
          this.getCacheValue([this.path, "scrollTop"])
        );
        // console.log(scrollTopValue, "scrollTopValue");
        if (typeof scrollTopValue !== "number" || Number.isNaN(scrollTopValue))
          return;
        this.setScrollTop(scrollTopValue);
      } catch (error) {}
    },
    setScrollTop(targetValue) {
      try {
        this.scrollTopEl.scrollTop = targetValue;
      } catch (error) {}
    },
    getScrollTopValue() {
      try {
        // console.log(this.scrollTopEl.scrollTop, "this.scrollTopEl.scrollTop");
        return this.scrollTopEl.scrollTop;
      } catch (error) {
        return null;
      }
    },
    cacheScrollTopValue() {
      this.setCache([this.path, "scrollTop"], this.getScrollTopValue());
    },
    getCacheValue(keys) {
      return getCache(keys);
    },
    setCache(keys, value) {
      return setCache(keys, value);
    },
  },
};

export default CacheScrollTop;
